export function PenIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M14.701 3.279a3 3 0 114.76 3.653l-8.501 11.08a3.001 3.001 0 01-3.252 1.044L7 20h12a1 1 0 110 2H5a1 1 0 01-.794-1.609l1.891-2.52a3.001 3.001 0 01.102-3.512l6.373-8.305L11.7 5.4 9.3 8.6a1 1 0 11-1.6-1.2l2.997-3.996.003-.004a.999.999 0 011.4-.2l.002.001 1.688 1.266.911-1.188zM7.786 15.576a1 1 0 00.177 1.396l.034.026a1 1 0 001.376-.204l6.4-8.34-1.601-1.2-6.386 8.322zm10.089-9.862a1 1 0 10-1.587-1.217l-.898 1.17 1.6 1.2.885-1.153z"
      ></path>
    </svg>
  );
}
